import { render, staticRenderFns } from "./EducationPreviewCard.vue?vue&type=template&id=75c8917e&scoped=true"
import script from "./EducationPreviewCard.vue?vue&type=script&lang=js"
export * from "./EducationPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./EducationPreviewCard.vue?vue&type=style&index=0&id=75c8917e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8917e",
  null
  
)

export default component.exports